export default "__VITE_ASSET__CMkOWAeD__"